<div class="container">
  <mic-breadcrumb id="casing-fitment-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('casingFitmentText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title" id="casing-fitment-heading">{{ translationService.translate('casingFitmentText') }}</h2>

  <div class="action-bar">
    <button id="reset-filters" class="btn-clear" type="button" mat-flat-button (click)="clearFilters()">
      <mat-icon>refresh</mat-icon>
      {{ translationService.translate('clearSelectionText') }}
    </button>

    <button id="export-button-top" class="btn-primary" mat-flat-button (click)="openExportModal()">
      <mat-icon>download</mat-icon>
      {{ translationService.translate('exportButtonText') }}
    </button>
  </div>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <mic-dropdown-search
          micDropdownAccessibility
          id="size"
          formControlName="size"
          [data]="sizeList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectSizeText') }}"
          label="{{ translationService.translate('sizeText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="series"
          formControlName="series"
          [data]="seriesList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectSeriesText') }}"
          label="{{ translationService.translate('seriesText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="treads"
          formControlName="treads"
          [data]="treadsList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectTreadText') }}"
          label="{{ translationService.translate('treadText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>
      </div>
    </form>
  </mat-card>

  <div id="casing-fitment-table" class="cam-table table-container">
    <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>
    </mic-table>
  </div>
</div>
